<div *ngIf="loggedIn">
  <div
    *ngIf="
      isChannelPartner &&
      channelPartners?.length &&
      fromPage !== 'manage-user' &&
      fromPage !== 'order-confirmation' &&
      fromPage !== 'quote-confirmation'
    "
  >
    <div class="manager-Details" *ngFor="let partner of channelPartners">
      <div class="detail-header">
        <span class="material-icons">contact_mail</span>
        <span
          class="detail-title"
          *ngIf="partner.contactUsPartnerType === 'ORDERMANAGER'"
          >{{ "contactusform.reachedcontactorder" | cxTranslate }}</span
        >
        <span
          class="detail-title"
          *ngIf="partner.contactUsPartnerType === 'SALESMANAGER'"
          >{{ "contactusform.reachedcontactsales" | cxTranslate }}</span
        >
        <span
          class="detail-title"
          *ngIf="
            partner.contactUsPartnerType !== 'SALESMANAGER' &&
            partner.contactUsPartnerType !== 'ORDERMANAGER'
          "
        >
          {{ partner.contactUsPartnerType }}
        </span>
      </div>
      <hr />
      <div class="details-body">
        <div class="address-group">
          <div class="label">{{ "contactusform.reachedcontactname" | cxTranslate }}</div>
          <div class="content">{{ partner.contactName }}</div>
        </div>
        <div class="address-group">
          <div class="label">{{ "contactusform.reachedcontactphno" | cxTranslate }}</div>
          <div class="content">{{ partner.phoneNumber }}</div>
        </div>

        <div class="address-group">
          <div class="label">{{ "contactusform.reachedcontactlegal" | cxTranslate }}</div>
          <div class="content">{{ partner.legalEntityName }}</div>
        </div>

        <div class="address-group">
          <div class="label">{{ "contactusform.reachedcontactmail" | cxTranslate }}</div>
          <div class="content">
            <div class="contactus-mail">{{ partner.mailId }}</div>
          </div>
        </div>

        <div class="address-group">
          <div class="label">{{ "contactusform.reachedcontacttype" | cxTranslate }}</div>
          <div class="content">{{ partner.type }}</div>
        </div>

        <div class="address-group">
          <div class="label">{{ "contactusform.reachedcontactregion" | cxTranslate }}</div>
          <div class="content">{{ partner.region }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="contactus-search">
      <input
        matInput
        (keyup)="applyFilter($event)"
        placeholder='{{ "contactusform.searchPlaceholder" | cxTranslate }}'
        #input
        class="contactus-searchbox"
      />
      <i class="material-icons contactus-searchicon"> search</i>
    </div>

    <table mat-table [dataSource]="dataSource" matSort class="contactus-table">
      <ng-container matColumnDef="productLine">
        <th mat-header-cell *matHeaderCellDef class="headerTypewidth">{{ "contactusform.reachedcontacttype" | cxTranslate }}</th>
        <td mat-cell *matCellDef="let contact">{{ contact.productLine }}</td>
      </ng-container>

      <ng-container matColumnDef="region">
        <th
          mat-header-cell
          class="headerRegionwidth"
          *matHeaderCellDef
          mat-sort-header
        >
        {{ "contactusform.reachedcontactregion" | cxTranslate }}
          <button
            class="material-icons mdc-icon-button"
            (click)="sortContact('region')"
          >
            unfold_more
          </button>
        </th>
        <td mat-cell class="headerwidth" *matCellDef="let contact">
          {{ contact.region }}
        </td>
      </ng-container>

      <ng-container matColumnDef="salesArea">
        <th
          mat-header-cell
          class="headerBussinesswidth"
          *matHeaderCellDef
          mat-sort-header
        >
        {{ "contactusform.reachedcontactbusiness" | cxTranslate }}
          <button
            class="material-icons mdc-icon-button"
            (click)="sortContact('salesArea')"
          >
            unfold_more
          </button>
        </th>
        <td mat-cell *matCellDef="let contact">{{ contact.salesArea }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell class="headerMailwidth" *matHeaderCellDef>
          {{ "contactusform.reachedcontactmail" | cxTranslate }}
        </th>
        <td mat-cell class="mailColumn" *matCellDef="let contact">
          {{ contact.email }}
        </td>
      </ng-container>

      <ng-container matColumnDef="phoneNum">
        <th mat-header-cell class="headerPhonewidth" *matHeaderCellDef>
          {{ "contactusform.reachedcontactphoneno" | cxTranslate }} 
        </th>
        <td mat-cell *matCellDef="let contact">{{ contact.phoneNum }}</td>
      </ng-container>

      <ng-container matColumnDef="workingHours">
        <th mat-header-cell class="headerWorkingwidth" *matHeaderCellDef>
          {{ "contactusform.reachedcontactworkinghrs" | cxTranslate }}
        </th>
        <td mat-cell *matCellDef="let contact">{{ contact.workingHours }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; let i = index; columns: displayedColumns"
      ></tr>
    </table>
    <div *ngIf="isShowAll">
      <p class="contactus-viewall" (click)="viewAll()">{{ "contactusform.reachedcontactviewall" | cxTranslate }}</p>
    </div>
  </div>
</div>

<div *ngIf="!loggedIn">
  <app-contactform></app-contactform>
</div>
